<template>
  <div>
    <b-card>
      <template v-if="allNotifications.length === 0">
        <div class="p-1 text-center">لا توجد إشعارات بعد</div>
      </template>
      <b-list-group class="w-50">
        <b-list-group-item
          v-for="notification in allNotifications"
          :key="notification.id"
          :to="getUrl(notification.data)"
        >
          <div class="d-flex justify-content-between">
            <div>
              <h5>
                <span class="font-weight-bolder">
                  {{ notification.data.title }}
                </span>
              </h5>
              <small class="notification-text">{{
                notification.data.body
              }}</small>
            </div>
            <time>
              {{
                $moment(notification.created_at).format("YYYY-MM-DD , h:mm a")
              }}
            </time>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BListGroup,
  BListGroupItem,
  BContainer,
  BCol,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { formatDateToHuman } from "@/@core/utils/filter";
export default {
  components: {
    BCard,
    BRow,
    BListGroup,
    BListGroupItem,
    BContainer,
    BCol,
  },

  methods: {
    formatDateToHuman,
    ...mapActions("User", ["readNotifications"]),
    getUrl(notification) {
      var name = notification.notificationType.name;
      var url = notification.notificationType.url;

      if (name === "dynamic") return undefined;
      else {
        if (name === "regulations") return url + notification.regulation_id;
        else return url;
      }
    },
  },

  computed: {
    ...mapGetters("User", ["notifications", "allNotifications"]),
  },

  created() {
    this.readNotifications();
  },
};
</script>

<style lang="scss" scoped>
[dir="rtl"] .number-display {
  direction: ltr;
  width: fit-content;
  writing-mode: lr;
}
</style>
